Object.defineProperty(exports, '__esModule', {
  value: true
});
var regex_patterns = require('./patterns.js');
var isValidAccountNumber = function isValidAccountNumber(accountNumber) {
  return regex_patterns.ACCOUNT_NUMBER_REGEX.test(accountNumber);
};
var isValidEmailAddress = function isValidEmailAddress(emailAddress) {
  if (typeof emailAddress !== "string") return false;
  return Boolean(emailAddress.trim().match(regex_patterns.EMAIL_ADDRESS_REGEX));
};
var isValidDrivingLicenceNumber = function isValidDrivingLicenceNumber(licenceNumber) {
  if (typeof licenceNumber !== "string") return false;
  return Boolean(licenceNumber.trim().match(regex_patterns.DRIVING_LICENCE_REGEX));
};
var isValidPostCode = function isValidPostCode(postcode) {
  if (typeof postcode !== "string") return false;
  return Boolean(postcode.trim().match(regex_patterns.POSTCODE_REGEX));
};
var isValidSortcode = function isValidSortcode(sortCode) {
  return regex_patterns.SORTCODE_REGEX.test(sortCode);
};
var isValidVehicleRegistration = function isValidVehicleRegistration(registration) {
  if (typeof registration !== "string") return false;
  return Boolean(registration.trim().match(regex_patterns.VEHICLE_REGISTRATION_REGEX));
};
exports.isValidAccountNumber = isValidAccountNumber;
exports.isValidDrivingLicenceNumber = isValidDrivingLicenceNumber;
exports.isValidEmailAddress = isValidEmailAddress;
exports.isValidPostCode = isValidPostCode;
exports.isValidSortcode = isValidSortcode;
exports.isValidVehicleRegistration = isValidVehicleRegistration;